import { Controller } from "@hotwired/stimulus"

// Controller for client-side tab switching
// Used in scan view to switch between search results and scanned products
export default class extends Controller {
    static targets = ["tab", "panel"]
    static values = {
        activeTab: { type: String, default: "search" }
    }

    connect() {
        const urlTab = this.getUrlTab()
        if (urlTab) this.activeTabValue = urlTab
        this.showPanel(this.activeTabValue)
    }

    switch(event) {
        event.preventDefault()
        const tabName = event.currentTarget.dataset.tabName
        this.activeTabValue = tabName
        this.showPanel(tabName)
        this.setUrlTab(tabName)
    }

    showPanel(tabName) {
        // Update tab active states
        this.tabTargets.forEach(tab => {
            if (tab.dataset.tabName === tabName) {
                tab.classList.add("filter-tabs__tab--active")
            } else {
                tab.classList.remove("filter-tabs__tab--active")
            }
        })

        // Update panel visibility
        this.panelTargets.forEach(panel => {
            if (panel.dataset.tabPanel === tabName) {
                panel.classList.remove("hidden")
            } else {
                panel.classList.add("hidden")
            }
        })
    }

    // Public method to switch tabs programmatically
    switchTo(tabName) {
        this.activeTabValue = tabName
        this.showPanel(tabName)
    }

    getUrlTab() {
        try {
            const url = new URL(window.location.href)
            const tab = url.searchParams.get("tab")
            if (!tab) return null

            const allowed = this.tabTargets.map(t => t.dataset.tabName)
            return allowed.includes(tab) ? tab : null
        } catch (_e) {
            return null
        }
    }

    setUrlTab(tabName) {
        try {
            const url = new URL(window.location.href)
            url.searchParams.set("tab", tabName)
            window.history.replaceState({}, "", url.toString())
        } catch (_e) {
            // ignore
        }
    }
}
